export default "__VITE_ASSET__DcuFtMLT__"